import { SystemMdcEvent } from "phoenix/redux/models/Messages/ClientMessageDeliveryControls";
import { SnexMessage } from "phoenix/redux/models/Messages/SnexMessage";

export interface ShowToastEnvProps {inAppToast: SystemMdcEvent, inAppEffect: SystemMdcEvent}
export const shouldShowToast = (props?: ShowToastEnvProps, message?: SnexMessage) => {
    if (!message || !props) return false;
    const toastMode = props?.inAppToast?.mode;
    const effectMode = props?.inAppEffect?.mode;
    return (toastMode === 'enabled' || toastMode === 'is-online') && (effectMode === 'enabled' || effectMode === 'is-online');
}